import React, { PureComponent, PropTypes } from 'react';
import { Roles } from '../ApplicationModel';

export default class AdminFeature extends PureComponent {
  static contextTypes = {
    model: PropTypes.object.isRequired,
  };

  static propTypes = {
    alternate: PropTypes.node,
  };

  static defaultProps = {
    alternate: null,
  };

  static canAccess = (model) => model.hasAccountRole(model.getAccountId(), Roles.Admin) || model.isSuperAdmin();

  render() {
    if (AdminFeature.canAccess(this.context.model)) {
      return React.Children.only(this.props.children);
    } else {
      return this.props.alternate;
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/common/access/AdminFeature.jsx